var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg025Rewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.999,329.969c11.047,0,20.001-8.955,20.001-20.001V102.224c0-24.734-14.197-45.979-37.051-55.44 c-22.828-9.452-47.853-4.481-65.333,12.962l-133.63,131.694v-89.215c0-24.734-14.198-45.98-37.051-55.441 c-22.826-9.448-47.852-4.481-65.332,12.964L17.64,213.447c-0.036,0.035-0.071,0.071-0.107,0.106 C-5.845,236.944-5.844,275,17.535,298.389c0.04,0.04,0.08,0.08,0.121,0.12l156.248,153.682 c11.617,11.589,26.543,17.667,41.926,17.666c7.732,0,15.583-1.536,23.18-4.683c22.807-9.442,36.975-30.696,36.975-55.469V320.5 l133.616,131.669c11.67,11.653,26.677,17.765,42.153,17.765c7.786,0,15.695-1.549,23.35-4.719 c22.757-9.422,36.894-30.589,36.894-55.24c0-11.047-8.955-20.001-20.001-20.001s-20.001,8.955-20.001,20.001 c0,12.278-9.333,17.097-12.193,18.28c-2.911,1.206-13.102,4.448-21.956-4.41c-0.036-0.037-0.072-0.073-0.109-0.108 L281.794,270.063c-7.729-7.783-7.729-20.398,0-28.184L437.74,88.194c0.036-0.036,0.072-0.072,0.108-0.107 c8.768-8.774,18.901-5.543,21.798-4.342c2.897,1.199,12.351,6.076,12.351,18.48v207.744 C471.998,321.015,480.952,329.969,491.999,329.969z M223.71,428.216c-2.856,1.182-12.854,4.362-21.581-4.372 c-0.041-0.04-0.082-0.081-0.123-0.121L45.783,270.066c-7.732-7.783-7.733-20.4-0.003-28.187L201.726,88.194 c0.036-0.036,0.073-0.072,0.109-0.108c8.766-8.771,18.9-5.541,21.797-4.342c2.897,1.199,12.351,6.077,12.351,18.48v307.482h0.001 C235.984,422.166,226.589,427.023,223.71,428.216z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg025Rewind);
export default __webpack_public_path__ + "static/media/025-rewind.fa7e53d61d62335f61dc0dd260cb9fec.svg";
export { ForwardRef as ReactComponent };